import * as moment from "moment";

import { DropdownOption } from "@teamprevent/common/questionnaires/model";

export interface PartiallyMatchedEmployeeListModel {
    readonly id: string;
    readonly customerId: string;
    readonly customerName?: string;
    readonly referredName?: string;
    readonly formType?: string;
}

export const MatchFieldTypes = {
    FirstName: "firstName",
    LastName: "lastName",
    EmailAddress: "emailAddress",
    DateOfBirth: "dateOfBirth",
    EmployeeUniqueId: "employeeUniqueId",
    Postcode: "postcode",
    CustomerName: "customerName",
    TerminationDate: "terminationDate",
    MobilePhoneNumber: "mobilePhoneNumber",
    JobTitle: "jobTitle",
    OrgStructureOneName: "orgStructureOneName"
} as const;

export interface EmployeePartialMatch {
    readonly employeeRecordId: string;
    readonly customerId: string;
    readonly customerName: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly emailAddress: string;
    readonly dateOfBirth: moment.Moment;
    readonly employeeUniqueId: string;
    readonly postcode: string;
    readonly terminationDate?: string;
    readonly mobilePhoneNumber?: string;
    readonly jobTitle?: string;
    readonly orgStructureOneName?: string;
}

export interface PartiallyMatchedEmployeeDetailModel {
    readonly id: string;
    readonly customerId: string;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly emailAddress?: string;
    readonly dateOfBirth?: moment.Moment;
    readonly employeeUniqueId?: string;
    readonly postcode?: string;
    readonly customerName?: string;
    readonly partialMatchEmployeeRecords?: EmployeePartialMatch[];
    readonly detailUpdated?: moment.Moment;
    readonly terminationDate?: string;
    readonly mobilePhoneNumber?: string;
    readonly jobTitle?: string;
    readonly caseName?: string;
    readonly orgStructureOneName?: string;
}

export type PartiallyMatchedEmployeeListModelInRedux = PartiallyMatchedEmployeeListModel & { readonly listUpdated?: moment.Moment };
export type PartiallyMatchedEmployeeDetailModelInRedux  = PartiallyMatchedEmployeeDetailModel & { readonly detailUpdated?: moment.Moment };
export type PartiallyMatchedEmployee = PartiallyMatchedEmployeeListModel & PartiallyMatchedEmployeeDetailModel;
export type PartiallyMatchedEmployeeInRedux = PartiallyMatchedEmployeeListModelInRedux & PartiallyMatchedEmployeeDetailModelInRedux;

export enum MatchEmployeesResult {
    FullMatch = "FullMatch",
    PartialMatches = "PartialMatches",
    CreatedNew = "CreatedNew"
}

export const matchEmployeesResultOptions: DropdownOption[] = [
    { text: "Full Match", value: MatchEmployeesResult.FullMatch },
    { text: "Partially Match", value: MatchEmployeesResult.PartialMatches },
    { text: "New Employee", value: MatchEmployeesResult.CreatedNew }
];
